import { AuthLayout } from "components/layout/AuthLayout"
import { DefaultLayout } from "components/layout/DefaultLayout"
import { IndexPage } from "pages/IndexPage"
import { CompanyEditPage } from "pages/company/CompanyEditPage"
import { CompanyPage } from "pages/company/IndexPage"
import { NotFoundPage } from "pages/error/404"
import { ForgetPage } from "pages/forget/IndexPage"
import { JobseekerPage } from "pages/jobseeker/IndexPage"
import { LogInPage } from "pages/login/IndexPage"
import { PlanPage } from "pages/plan/IndexPage"
import { ProfilePage } from "pages/profile/IndexPage"
import { ProfileEditPage } from "pages/profile/ProfileEditPage"
import { RecruitPage } from "pages/recruit/IndexPage"
import { VisitLogPage } from "pages/recruit/VisitLogPage"
import { RecruitEditPage } from "pages/recruit/_id/EditPage"
import { RecruitShowPage } from "pages/recruit/_id/ShowPage"
import { RegisterPage } from "pages/register/IndexPage"
import { RegisterEmailPage } from "pages/register/RegisterEmailPage"
import { MailPage } from "pages/setting/MailPage"
import { PasswordPage } from "pages/setting/PasswordPage"
import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import {
  AuthorizedOnly as Auth,
  AuthorizedRegisterEmail,
} from "router/AuthorizedOnly"

export const BaseRouter: React.VFC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/">
        <Route element={<DefaultLayout />}>
          <Route
            path="/"
            element={
              <Auth>
                <IndexPage />
              </Auth>
            }
          />
          <Route
            path="/profile"
            element={
              <Auth>
                <ProfilePage />
              </Auth>
            }
          />
          <Route
            path="/profile/edit"
            element={
              <Auth>
                <ProfileEditPage />
              </Auth>
            }
          />
          <Route
            path="/company"
            element={
              <Auth>
                <CompanyPage />
              </Auth>
            }
          />
          <Route
            path="/plan"
            element={
              <Auth>
                <PlanPage />
              </Auth>
            }
          />
          <Route
            path="/company/edit"
            element={
              <Auth>
                <CompanyEditPage />
              </Auth>
            }
          />
          <Route
            path="/recruit/new"
            element={
              <Auth>
                <RecruitEditPage />
              </Auth>
            }
          />
          <Route
            path="/recruit/:id/edit"
            element={
              <Auth>
                <RecruitEditPage />
              </Auth>
            }
          />
          <Route
            path="/recruit/:id/show"
            element={
              <Auth>
                <RecruitShowPage />
              </Auth>
            }
          />
          <Route
            path="/recruit/visit-log"
            element={
              <Auth>
                <VisitLogPage />
              </Auth>
            }
          />
          <Route
            path="/jobseeker"
            element={
              <Auth>
                <JobseekerPage />
              </Auth>
            }
          />
          <Route
            path="/recruit"
            element={
              <Auth>
                <RecruitPage />
              </Auth>
            }
          />
          <Route
            path="/setting/email"
            element={
              <Auth>
                <MailPage />
              </Auth>
            }
          />
          <Route
            path="/setting/password"
            element={
              <Auth>
                <PasswordPage />
              </Auth>
            }
          />
        </Route>

        <Route element={<AuthLayout />}>
          <Route path="register" element={<RegisterPage />} />
          <Route
            path="register/mail"
            element={
              <AuthorizedRegisterEmail>
                <RegisterEmailPage />
              </AuthorizedRegisterEmail>
            }
          />
          <Route path="login" element={<LogInPage />} />
          <Route path="forget" element={<ForgetPage />} />
          <Route path="error/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>
)
